module.exports = __webpack_public_path__ + "img/new_logo.3c476998.svg";